import {PersonnelService,} from "@/common/api.service";
import {CANCEL_MANAGE_COMPANY_EDIT_STATE, FETCH_ECS_COMPANY, FETCH_ECS_COMPANY_LIST, SAVE_MANAGE_COMPANY,SAVE_EDITED_ECS_COMPANY, SAVE_NEW_ECS_COMPANY,} from "./actions";
import {FATAL_FETCH_ERROR,} from "../person/mutations";
import {FETCH_ECS_COMPANY_LIST_END, FETCH_ECS_COMPANY_START, SET_ECS_COMPANY, TOGGLE_MANAGE_COMPANY_EDIT_STATE, UPDATE_MANAGE_COMPANY_FIELD,LOAD_ECS_COMPANY_TO_EDIT, 
    RESET_DEFAULT_NEW_ECS_COMPANY, RESET_DEFAULT_NEW_ECS_COMPANY_LIST, RESET_DEFAULT_ECS_COMPANY_TO_EDIT, TOGGLE_EDIT_ECS_COMPANY_DIALOG, TOGGLE_NEW_ECS_COMPANY_DIALOG, UPDATE_ECS_COMPANY_FIELD, UPDATE_ADD_ECS_COMPANY_FIELD,} from "./mutations";
import {SET_TOASTER_MESSAGE} from "../this_app/mutations";

const getDefaultState = () => {
    return {
        loadingEcsCompany: false,
        ecsCompany: {
            name: ''
        },
        ecsCompanyList: [],
        editEcsCompanyDialog: false,
        addEcsCompany: {
            name: '',
            isActive: true
        },
        editEcsCompany: {},
        addEcsCompanyDialog: false,
        editStateEcsCompanies: {
            name: false,
            addressLineOne: false,
            addressLineTwo: false,
            town: false,
            country: false,
            county: false,
            postCode: false,
            faxNumber: false,
            telephoneNumber: false,
            websiteAddress: false,
            isActive: true,
            isLimitedCompany: false,
            registrationNumber: false,    
        },
    }
};

const state = {
    loadingEcsCompany: false,
    ecsCompany: {},
    ecsCompanyList: [],
    editEcsCompanyDialog: false,
    addEcsCompany: {
        name: '',
        isActive: true
    },
    editEcsCompany: {},
    addEcsCompanyDialog: false,
    editStateEcsCompanies: {
        name: false,
        addressLineOne: false,
        addressLineTwo: false,
        town: false,
        country: false,
        county: false,
        postCode: false,
        faxNumber: false,
        telephoneNumber: false,
        websiteAddress: false,
        isActive: true,
        isLimitedCompany: false,
        registrationNumber: false,
    },
};

const getters = {
    ecsCompany(state) {
        return state.ecsCompany;
    },
    ecsCompanyList(state) {
        return state.ecsCompanyList;
    },
    editStateEcsCompanies(state) {
        return state.editStateEcsCompanies;
    },
    getEcsCompanyNameById: (state) => (ecsCompanyId) => {

        const ecsCompany = state.ecsCompanyList.find(ecsCompany => ecsCompany.ecsCompanyId == ecsCompanyId);
        if (ecsCompany) {
            return ecsCompany.name;
        }
    },
    addEcsCompanyDialog(state) {
        return state.addEcsCompanyDialog;
    },
};

const actions = {
    [FETCH_ECS_COMPANY_LIST]({commit}) {
        return PersonnelService.getAllEcsCompanies()
            .then(({data}) => {
                commit(FETCH_ECS_COMPANY_LIST_END, data);
            })
            .catch(error => {
                commit(FATAL_FETCH_ERROR, {state: true, value: "FETCH_ECS_COMPANY_LIST"});
                throw new Error(error);
            });
    },
    [FETCH_ECS_COMPANY]({commit}, ecsCompanyId) {
        commit(FETCH_ECS_COMPANY_START);
        return PersonnelService.getEcsCompany(ecsCompanyId)
            .then(({data}) => {
                commit(SET_ECS_COMPANY, data);
            })
            .catch(error => {
                throw new Error(error);
            });
    },
    [CANCEL_MANAGE_COMPANY_EDIT_STATE]({commit, dispatch}, params) {
        dispatch(FETCH_ECS_COMPANY_LIST, params.personId);
        commit(TOGGLE_MANAGE_COMPANY_EDIT_STATE, params.field);
    },
    [SAVE_MANAGE_COMPANY]({commit, dispatch}, params) {
        return PersonnelService.updateEcsCompanyDetails(params)
            .then(({data}) => {
                commit(TOGGLE_MANAGE_COMPANY_EDIT_STATE, params.field);
                dispatch(FETCH_ECS_COMPANY, params.ecsCompany.ecsCompanyId);
                return data;
            });
    },
    [SAVE_EDITED_ECS_COMPANY]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const editedEcsCompany = state.editEcsCompany;
        return PersonnelService.updateEcsCompany(editedEcsCompany)
        .then(({data}) => {
            commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record updated'});
            commit(RESET_DEFAULT_ECS_COMPANY_TO_EDIT);
            dispatch(FETCH_ECS_COMPANY_LIST);
            return data;
        })
        .catch(() => {
            commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to update ecs company'});
        });
    },
    [SAVE_NEW_ECS_COMPANY]({commit, dispatch}) {
        //Put this here as it will get lost with reset
        const newEcsCompany = state.addEcsCompany;
        return PersonnelService.saveEcsCompany(newEcsCompany)
        .then(() => {
            commit(SET_TOASTER_MESSAGE, {state: true, value: 'Record saved'});
            dispatch(FETCH_ECS_COMPANY_LIST);
            // return data;
        })
        .catch(() => {
            commit(SET_TOASTER_MESSAGE, {state: true, value: 'Failed to save ecs company'});
        });
    },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [TOGGLE_MANAGE_COMPANY_EDIT_STATE](state, field) {
        state.editStateEcsCompanies[field] = !state.editStateEcsCompanies[field];
    },
    [UPDATE_MANAGE_COMPANY_FIELD](state, data) {
        state.ecsCompany[data.field] = data.value;
    },
    [FETCH_ECS_COMPANY_START](state) {
        state.loadingEcsCompany = true;
    },
    [FETCH_ECS_COMPANY_LIST_END](state, data) {
        state.ecsCompanyList = data;
        state.isLoading = false;
    },
    [SET_ECS_COMPANY](state, data) {
        state.ecsCompany = data;
        state.loadingEcsCompany = false;
    },
    [UPDATE_ADD_ECS_COMPANY_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.addEcsCompany[data.objectKey][0][data.key] = data.value;
        } else {
            state.addEcsCompany[data.key] = data.value;
        }
    },
    [UPDATE_ECS_COMPANY_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.editEcsCompany[data.objectKey][0][data.key] = data.value;
        } else {
            state.editEcsCompany[data.key] = data.value;
        }
    },
    [RESET_DEFAULT_NEW_ECS_COMPANY](state) {
        state.addEcsCompany = getDefaultState().ecsCompany;
    },
    [RESET_DEFAULT_NEW_ECS_COMPANY_LIST](state) {
        // state.ecsCompanyList = [];
        state.employedDates = [];
        state.ecsCompanyList = getDefaultState().ecsCompanyList;
    },
    [TOGGLE_NEW_ECS_COMPANY_DIALOG](state) {
        state.addEcsCompanyDialog = !state.addEcsCompanyDialog;
    },
    [TOGGLE_EDIT_ECS_COMPANY_DIALOG](state) {
        state.editEcsCompanyDialog = !state.editEcsCompanyDialog;
    },
    [LOAD_ECS_COMPANY_TO_EDIT](state, ecsCompanyId) {
        // noinspection UnnecessaryLocalVariableJS
        const itemToEdit = state.ecsCompanyList.find(
        (list) => list.ecsCompanyId == ecsCompanyId
        );
        state.editEcsCompany = itemToEdit;
    },

    [RESET_DEFAULT_ECS_COMPANY_TO_EDIT](state) {
        state.editEcsCompany = getDefaultState().ecsCompany;
    },
};


export default {
    state,
    getters,
    actions,
    mutations,
};
